"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SCREEN_SHARING = exports.AUDIO_VIDEO = exports.VIDEO = exports.AUDIO = void 0;

/**
 * The available stream types
 * @typedef {Object} StreamTypes
 * @property {string} AUDIO='audio' - Audio communication service
 * @property {string} VIDEO='video' - Video communication service
 * @property {string} AUDIO_VIDEO='audio-video' - Audio and video communication service
 * @property {string} SCREEN_SHARING='screen-sharing' - Screen-sharing communication service
 */

/**
 * Audio communication service
 * @ignore
 * @type {string}
 */
var AUDIO = 'audio';
/**
 * Video communication service
 * @ignore
 * @type {string}
 */

exports.AUDIO = AUDIO;
var VIDEO = 'video';
/**
 * Audio and video communication service
 * @ignore
 * @type {string}
 */

exports.VIDEO = VIDEO;
var AUDIO_VIDEO = 'audio-video';
/**
 * Screen-sharing service
 * @ignore
 * @type {string}
 */

exports.AUDIO_VIDEO = AUDIO_VIDEO;
var SCREEN_SHARING = 'screen-sharing';
exports.SCREEN_SHARING = SCREEN_SHARING;
var _default = {
  AUDIO: AUDIO,
  VIDEO: VIDEO,
  AUDIO_VIDEO: AUDIO_VIDEO,
  SCREEN_SHARING: SCREEN_SHARING
};
exports.default = _default;